import type { Manifest } from '@/types/manifest';

export const InstallPages = Symbol.for('InstallPages');

export interface InstallPages {
    getManifests: () => Manifest[];
    getToolManifests: () => Manifest[];
    getPageManifests: () => Manifest[];
    getEntryManifest: () => Manifest;
}
